import { I18nAndL10n } from '@application/i18n/mod';
import { withTranslation } from '@application/i18n/with_translation';
import { UniversalConfig } from '@application/universal_config.service';
import { Flag, Flex, InputSelect, Text } from '@cellula/react';
import { tokens } from '@cellula/react-theme-patient';
import { ConsentTrigger } from '@component/consent/consent_trigger.component';
import { LanguageSelect } from '@feature/language_select';
import { localeToCountry } from '@module/locale_to_country_code';
import { useResolve, useResolveController, withNewContainer } from '@visiba/instantiation';
import styled from 'styled-components';
import { AboutUsText } from './_about_us_text.component';
import { AddressSection } from './_address_section.component';
import { AppSection } from './_app_section.component';
import { ExternalLink } from './_external_link.component';
import { LegalLinks } from './_legal_links.component';
import { FooterController } from './footer.controller';

const elements = {
	footer: styled.footer`
		border-top: 1px solid ${tokens.color.border.brand};
		background: ${tokens.color.bg.surfaceBrand};
		padding: ${tokens.spacing.x3};

		${tokens.breakpointQuery.medium} {
			padding: ${tokens.spacing.x4};
		}
	`,
	footerGrid: styled.div`
		max-width: 1200px;
		width: 100%;
		margin: 0 auto;
		display: grid;
		grid-template-columns: repeat(1, 1fr);
		gap: ${tokens.spacing.x4};

		${tokens.breakpointQuery.medium} {
			grid-template-columns: repeat(3, 1fr);
		}
	`,
	footerColumn: styled.div`
		display: flex;
		justify-content: flex-start;
		align-items: flex-start;
		flex-direction: column;
		gap: ${tokens.spacing.x1};

		${tokens.breakpointQuery.medium} {
			gap: ${tokens.spacing.x2};
		}
	`,
};

export const Footer = withNewContainer(function Footer() {
	const universalConfig = useResolve(UniversalConfig);

	return (
		<elements.footer>
			<elements.footerGrid>
				<elements.footerColumn>
					<Flex style={{ width: '100%' }}>
						<LanguageSelect />
					</Flex>
					<AddressSection />
					<ExternalLink />
				</elements.footerColumn>
				<elements.footerColumn>
					<Flex gap={tokens.spacing.x3} align='flex-start'>
						<AboutUsText />
						<LegalLinks />
						<ConsentTrigger />
					</Flex>
				</elements.footerColumn>
				{universalConfig.appConfig != null ? (
					<elements.footerColumn>
						<AppSection />
					</elements.footerColumn>
				) : null}
			</elements.footerGrid>
		</elements.footer>
	);
});
